const StatusLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "name",
                "tableName": "IDCUSTOMER",
                "label": "Customer Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }
            ,
            {
                "name": "address1",
                "tableName": "IDCUSTOMER",
                "label": "Address 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "address2",
                "tableName": "IDCUSTOMER",
                "label": "Address 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "city",
                "tableName": "IDCUSTOMER",
                "label": "City",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "state",
                "tableName": "IDCUSTOMER",
                "label": "State",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "zip",
                "tableName": "IDCUSTOMER",
                "label": "Zip",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
        ]
    },
    {
        "groupId": 2,
        "label": "Credit Analysis",
        "fields": [
            {
                "name": "creditLimit",
                "tableName": "IDCUSTOMER",
                "label": "Credit Limit",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }
            ,
            {
                "name": "totalBalance",
                "tableName": "IDCUSTOMER",
                "label": "Cur Balance",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "remainingBal",
                "tableName": "IDCUSTOMER",
                "label": "Remaining",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "invoiceBalance",
                "tableName": "IDCUSTOMER",
                "label": "Inv / Deb",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "debitBalance",
                "tableName": "IDCUSTOMER",
                "label": "Crd / Adj",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "financeChargeBalance",
                "tableName": "IDCUSTOMER",
                "label": "Fin. Charges",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            }
        ]
    },
    {
        "groupId": 3,
        "label": "Credit Information",
        "fields": [
            {
                "name": "creditstatusflag",
                "tableName": "IDCUSTOMER",
                "label": "Credit Status",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }
            ,
            {
                "name": "creditLimit",
                "tableName": "IDCUSTOMER",
                "label": "Credit Limit",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "creditrating",
                "tableName": "IDCUSTOMER",
                "label": "Ratings",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "creditlastreviewdate",
                "tableName": "IDCUSTOMER",
                "label": "Last Review",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "creditnextreviewdate",
                "tableName": "IDCUSTOMER",
                "label": "Next Review",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "dateopened",
                "tableName": "IDCUSTOMER",
                "label": "Date Opened",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "higheststatementbalance",
                "tableName": "IDCUSTOMER",
                "label": "Hghest Stmnt",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "creditcomment",
                "tableName": "IDCUSTOMER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
        ]
    },
    {
        "groupId": 4,
        "label": "AR Open Items",
        "fields": [
            {
                "name": "under0",
                "tableName": "IDCUSTOMER",
                "label": "Current",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }
            ,
            {
                "name": "fromZeero",
                "tableName": "IDCUSTOMER",
                "label": "<= 30",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "fromThirtyOne",
                "tableName": "IDCUSTOMER",
                "label": "31 - 60",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "fromSixtyOne",
                "tableName": "IDCUSTOMER",
                "label": "61 - 90",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "fromNintyOne",
                "tableName": "IDCUSTOMER",
                "label": "91 - 120",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "OverOneTwenty",
                "tableName": "IDCUSTOMER",
                "label": "121 - Over",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "total",
                "tableName": "IDCUSTOMER",
                "label": "Total",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
        ]
    }
]
const OMStatusLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "name",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }
            ,
            {
                "name": "address1",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "address2",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "city",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "state",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "zip",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
        ]
    },
    {
        "groupId": 2,
        "label": "Credit Analysis",
        "fields": [
            {
                "name": "creditLimit",
                "tableName": "IDCUSTOMER",
                "label": "Credit Limit",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }
            ,
            {
                "name": "totalBalance",
                "tableName": "IDCUSTOMER",
                "label": "Cur Balance",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "openOrderAmount",
                "tableName": "IDCUSTOMER",
                "label": "OM Orders",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "remainingBal",
                "tableName": "IDCUSTOMER",
                "label": "Remaining",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "invoiceBalance",
                "tableName": "IDCUSTOMER",
                "label": "Inv / Deb",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "debitBalance",
                "tableName": "IDCUSTOMER",
                "label": "Crd / Adj",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "financeChargeBalance",
                "tableName": "IDCUSTOMER",
                "label": "Fin. Charges",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            }
        ]
    },
    {
        "groupId": 3,
        "label": "Credit Information",
        "fields": [
            {
                "name": "creditstatusflag",
                "tableName": "IDCUSTOMER",
                "label": "Credit Status",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }
            ,
            {
                "name": "creditLimit",
                "tableName": "IDCUSTOMER",
                "label": "Credit Limit",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "creditrating",
                "tableName": "IDCUSTOMER",
                "label": "Ratings",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "creditlastreviewdate",
                "tableName": "IDCUSTOMER",
                "label": "Last Review",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "creditnextreviewdate",
                "tableName": "IDCUSTOMER",
                "label": "Next Review",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "dateopened",
                "tableName": "IDCUSTOMER",
                "label": "Date Opened",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "higheststatementbalance",
                "tableName": "IDCUSTOMER",
                "label": "Hghest Stmnt",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "creditcomment",
                "tableName": "IDCUSTOMER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
        ]
    },
    {
        "groupId": 4,
        "label": "AR Open Items",
        "fields": [
            {
                "name": "under0",
                "tableName": "IDCUSTOMER",
                "label": "Current",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }
            ,
            {
                "name": "fromZeero",
                "tableName": "IDCUSTOMER",
                "label": "<= 30",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "fromThirtyOne",
                "tableName": "IDCUSTOMER",
                "label": "31 - 60",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "fromSixtyOne",
                "tableName": "IDCUSTOMER",
                "label": "61 - 90",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "fromNintyOne",
                "tableName": "IDCUSTOMER",
                "label": "91 - 120",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "OverOneTwenty",
                "tableName": "IDCUSTOMER",
                "label": "121 - Over",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
            {
                "name": "total",
                "tableName": "IDCUSTOMER",
                "label": "Total",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true

            },
        ]
    }
]
const SummaryLayout = [
    {
        "groupId": 1,
        "label": "MTD",
        "fields": [
            {
                "name": "InvoiceMTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaymentMTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "DiscountMTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "CreditMTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },


            {
                "name": "PostedMTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidDueDateMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidLateMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "AvgDaysPayMTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "YTD",
        "fields": [
            {
                "name": "InvoiceYTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaymentYTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "DiscountYTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "CreditYTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },


            {
                "name": "PostedYTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidDueDateYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidLateYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "AvgDaysPayYTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "LTD",
        "fields": [
            {
                "name": "InvoiceLTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaymentLTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "DiscountLTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "CreditLTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },


            {
                "name": "PostedLTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidDueDateLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidLateLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "AvgDaysPayLTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Prior Year",
        "fields": [
            {
                "name": "InvoicePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaymentPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "DiscountPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "CreditPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },


            {
                "name": "PostedPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidDueDatePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "PaidLatePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "AvgDaysPayPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Date",
        "fields": [
            {
                "name": "Transactionduedate",
                "tableName": "IDCUSTOMER",
                "label": "Last Invoice",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "LastPaymentDate",
                "localizedField": "Datereceived",
                "tableName": "IDCUSTOMER",
                "label": "Last Cash Rec",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "LastStmDate",
                "localizedField": "LASTSTATEMENTDATE",
                "tableName": "IDCUSTOMER",
                "label": "Last Stm Bal",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            }
        ]
    },
    {
        "groupId": 6,
        "label": "Type",
        "fields": [
            {
                "name": "Transactiontype",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            }
        ]
    }
    ,
    {
        "groupId": 7,
        "label": "Number",
        "fields": [
            {
                "name": "Transactionnumber",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "LastPaymentReference",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            }
        ]
    }
    ,
    {
        "groupId": 8,
        "label": "Amount",
        "fields": [
            {
                "name": "Amt1",
                "localizedField": "Amount",
                "tableName": "Aropenitemdetails",
                "label": "",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "LastPaymentAmount",
                "localizedField": "Amount",
                "tableName": "Aropenitemdetails",
                "label": "",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            },
            {
                "name": "LastStmBalance",
                "localizedField": "LASTSTATEMENTDATE",
                "tableName": "IDCUSTOMER",
                "label": "",
                "type": "number",
                "format": "$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true,
            }
        ]
    }
]
const OnlySummaryLayout = [
    {
        "groupId": 1,
        "label": "MTD",
        "fields": [
            {
                "name": "InvoiceMTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaymentMTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountMTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreditMTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },


            {
                "name": "PostedMTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidDueDateMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLateMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AvgDaysPayMTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "YTD",
        "fields": [
            {
                "name": "InvoiceYTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaymentYTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountYTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreditYTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },


            {
                "name": "PostedYTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidDueDateYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLateYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AvgDaysPayYTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "LTD",
        "fields": [
            {
                "name": "InvoiceLTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaymentLTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountLTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreditLTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },


            {
                "name": "PostedLTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidDueDateLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLateLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AvgDaysPayLTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Prior Year",
        "fields": [
            {
                "name": "InvoicePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaymentPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreditPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },


            {
                "name": "PostedPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidDueDatePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLatePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AvgDaysPayPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const SerialNumberForm = {

        "fields": [
            {
                "name": "Damageflag",
                "tableName": "WMSERIALNUMBER",
                "label": "Damage Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Damagedescription",
                "tableName": "WMSERIALNUMBER",
                "label": "Damage Desc",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "maxLength":40,
            },
            {
                "name": "OriginalNetWeight",
                "tableName": "WMSERIALNUMBER",
                "label": "Org Net Wgt",
                "type": "number",
                "format": "#,##0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "OriginalGrossWeight",
                "tableName": "WMSERIALNUMBER",
                "label": "Org Gross Wgt",
                "type": "number",
                "format": "#,##0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Packageid",
                "tableName": "WMSERIALNUMBER",
                "label": "Package ID",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "maxLength":20,
            },
            {
                "name": "UserDefinedRefrence2",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "maxLength":50,
            },
            {
                "name": "UserDefinedRefrence3",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "maxLength":50,
            },
            {
                "name": "UserDefinedRefrence4",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "maxLength":50,
            },
            {
                "name": "UserDefinedRefrence5",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "maxLength":50,
            },
            {
                "name": "Comment",
                "tableName": "WMSERIALNUMBER",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
export {
    StatusLayout,
    SummaryLayout,
    OnlySummaryLayout,
    SerialNumberForm,
    OMStatusLayout
}